export default __webpack_public_path__ + "static/media/main-img.b40d294d.svg";